import React, { useEffect, useState } from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useNavigate } from 'react-router-dom'

import { FormGarantia } from './FormGarantia/FormGarantia'
import { FormArchivosGarantia } from './FormArchivosGarantia/FormArchivosGarantia'
import { TableGarantia } from './TableGarantia/TableGarantia'

import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    Button,
    FormGroup,
} from 'reactstrap'

import { useFetchGarantias } from '../Garantias/hooks/useFetchGarantias'

const Garantias = () => {
    const navigate = useNavigate()

    // Hook: Para el select que trae todos los registros
    const [garantias, setGarantias] = useState([])

    // Hook: Para el select que trae todos los registros de casas
    const [clientes, setClientes] = useState([])

    // Hook: Para el select que recupera un solo registro
    const [garantiaSelected, setGarantiaSelected] = useState({});

    // Hook: Para el select que recupera un solo registro
    const [detalleBienInmueble, setDetalleBienInmueble] = useState([])

    // Hook: Para Mostrar/Ocultar el Formulario
    const [showList, setShowList] = useState(true)

    //hook: para formulario de archivos
    const [ showListArchivos, setShowArchivos ] = useState(true)

    // Custom Hook: interacciones con la BD
    const { getGarantias, getGarantia, createGarantia, updateGarantia, enableGarantia, disableGarantia, deleteGarantia, getClientes, createDetalleGarantiaBienInmueble, createDetalleVehiculo, deleteDetalleBienInmueble, deleteDetalleVehiculo, getDetalleBienInmueble, deleteUnSoloDetalleBienInmueble } = useFetchGarantias()

    // const { getArchivosGarantia, createArchivosGarantia } = useFetchArchivosGarantia()

    const [state, setState] = useState(true);
    
    // ejecuta el select a la BD para recuperar todos los registros
    const listarGarantias = async () => {
        const res = await getGarantias()
        setGarantias(res)

        return res
    }

    //Función para listar Detalle de Bienes Inmuebles
    const listarDetalleBienInmueble = async (idgarantia) => {
        const resDetalleBienInmueble = await getDetalleBienInmueble(idgarantia)
        setDetalleBienInmueble(resDetalleBienInmueble)

        return resDetalleBienInmueble
    }

    // ejecuta el select a la BD para el selectlist de clientes
    const selectClientes = async () => {
        const res = await getClientes()
        setClientes(
            res.map(cliente => ({
                label: cliente.nombre,
                value: cliente.idcliente
            }))
        )

        console.log(clientes)

        return res
    }


    useEffect(() => {
        listarGarantias()
        selectClientes()
    }, [])

    // Recupera la información de un registro en base a su ID cuando se selecciona desde la Tabla de datos
    const handleClickMostrarRegistro = async (idgarantia, flag) => {
        // Recupera la información completa del registro seleccionado
        const res = await getGarantia(idgarantia)
        setGarantiaSelected({
            idgarantia: res.idgarantia,
            idcliente: res.idcliente,
            fecha_recepcion: res.fecha_recepcion,
            tipo_garantia: res.tipo_garantia,
            descripcion_corta: res.descripcion_corta,
            descripcion_larga: res.descripcion_larga,
            valor_garantia: res.valor_garantia,

            //Detalles de Bien Inmueble

            //Detalles de Vehículos
            placa: res.placa,
            color: res.color,
            modelo: res.modelo,
            marca: res.marca,
        })

        // Mostrar/Ocultar formulario
        if (flag === 'actualizar') {
            handleClickMostrarForm()
        } else {
            handleClickMostrarFormArchivos()
        }

        //Función para Extraer Detalle de Bien Inmueble
        if (res.tipo_garantia === 'BIEN INMUEBLE') {
            listarDetalleBienInmueble(idgarantia)
        }

    }

    // Muestra/Oculta el formulario
    const handleClickMostrarForm = () => {
        setShowList(!showList)
    }

    const handleClickMostrarFormArchivos = () => {
        setShowArchivos(!showListArchivos)
    }

    return (
        <AllowedAccess permissions={['ACCESOS', '49_ADMIN']} renderAuthFailed={<p>Error</p>}>
            <div className='content'>
                <div className={(showList === true && showListArchivos === true) ? 'panel-body' : 'd-none'} id='listadoregistros'>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardHeader>
                                    <CardTitle tag="h4">
                                        Garantías <i className='nc-icon nc-single-copy-04'></i> 
                                    </CardTitle>
                                    <Button color='primary' onClick={handleClickMostrarForm}>
                                        Agregar
                                    </Button>
                                    
                                </CardHeader>
                                <CardBody>
                                    <TableGarantia 
                                        // datos (listados, individuales)
                                        garantias={garantias}
                                        
                                        // hancleClicks
                                        handleClickMostrarRegistro={handleClickMostrarRegistro}

                                        // Funciones
                                        listarGarantias={listarGarantias}
                                        enableGarantia={enableGarantia}
                                        disableGarantia={disableGarantia}
                                        deleteGarantia={deleteGarantia}

                                        //Funciones para eliminar detalles de garantias
                                        deleteDetalleBienInmueble={deleteDetalleBienInmueble}
                                        deleteDetalleVehiculo={deleteDetalleVehiculo}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <div className={!showList ? 'panel-body' : 'd-none'} id='formularioregistros'>
                    <FormGarantia 
                        
                        // datos (listados, individuales)
                        garantiaSelected={garantiaSelected}

                        //Clientes para Select
                        clientes={clientes}

                        // HandleClicks
                        handleClickMostrarForm={handleClickMostrarForm}

                        // Funciones
                        setGarantiaSelected={setGarantiaSelected}
                        listarGarantias={listarGarantias}
                        getGarantia={getGarantia}
                        createGarantia={createGarantia}
                        updateGarantia={updateGarantia}
                        
                        //Función para registrar detalles de filas de Bien Inmueble
                        createDetalleGarantiaBienInmueble={ createDetalleGarantiaBienInmueble }

                        //Función para registrar detalles de vehículo
                        createDetalleVehiculo={ createDetalleVehiculo }

                        //Funciones para eliminar detalles de garantias
                        deleteDetalleBienInmueble={deleteDetalleBienInmueble}
                        deleteDetalleVehiculo={deleteDetalleVehiculo}

                        //Detalle de Bien Inmueble
                        listarDetalleBienInmueble = { listarDetalleBienInmueble }
                        setDetalleBienInmueble = { setDetalleBienInmueble }
                        detalleBienInmueble = { detalleBienInmueble }
                        deleteUnSoloDetalleBienInmueble = { deleteUnSoloDetalleBienInmueble }
                        
                    />
                </div>
            </div>
        </AllowedAccess>
    )
}

export {
    Garantias
}


